var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScoreInitialRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 11,
    viewBox: "0 0 56 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.5C0 5.22386 0.155314 5 0.346904 5H54.6531C54.8447 5 55 5.22386 55 5.5C55 5.77614 54.8447 6 54.6531 6H0.346904C0.155314 6 0 5.77614 0 5.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5139 0.201364C49.7823 -0.0671214 50.2177 -0.0671214 50.4861 0.201364L55.2986 5.01386C55.5671 5.28235 55.5671 5.71765 55.2986 5.98614L50.4861 10.7986C50.2177 11.0671 49.7823 11.0671 49.5139 10.7986C49.2454 10.5302 49.2454 10.0948 49.5139 9.82636L53.8402 5.5L49.5139 1.17364C49.2454 0.905151 49.2454 0.46985 49.5139 0.201364Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreInitialRightArrow);
export default __webpack_public_path__ + "static/media/score-initial-right-arrow.f7545998c385f8e17695e001fc1256e4.svg";
export { ForwardRef as ReactComponent };